export default "__VITE_ASSET__212ec311__"